module.exports = __webpack_public_path__ + "img/hoem_bg_color.db9fea60.svg";